import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import {
  useCreateDashboardAnalyticsColumn,
  useDeleteDashboardAnalyticsColumn
} from 'api/hooks/use-dashboard-analytics-columns'
import { useQueryClient } from 'react-query'
import { isAnalyticsColumnFiltered } from './utils'

function UpdateAnalyticsColumn({ analytic, dashboardId, currentAnalytics, disabled, filterParams }) {
  const queryClient = useQueryClient()

  const [isChecked, setIsChecked] = useState(() =>
    currentAnalytics.map((a) => a.id).includes(analytic.id)
  )

  // Update checked state when currentAnalytics changes (e.g., from group selection)
  useEffect(() => {
    setIsChecked(currentAnalytics.map((a) => a.id).includes(analytic.id))
  }, [currentAnalytics, analytic.id])
  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries(`dashboards/${dashboardId}`)
    }
  }
  const params = {
    dashboard_id: dashboardId,
    analytic_id: analytic.id
  }

  const { mutate: addColumn } = useCreateDashboardAnalyticsColumn({ params, options })
  const { mutate: deleteColumn } = useDeleteDashboardAnalyticsColumn({
    id: currentAnalytics.find(
      (a) => a.id === analytic.id
    )?.dashboard_analytics_column_id,
    options
  })

  // Check if this analytics column has active filters
  const isFiltered = isAnalyticsColumnFiltered(analytic, filterParams)

  const handleToggle = (e) => {
    // Prevent unchecking if the analytics column is filtered
    if (!e.target.checked && isFiltered) {
      e.preventDefault()
      return
    }

    setIsChecked(e.target.checked)
    if (e.target.checked) {
      addColumn()
    } else {
      deleteColumn()
    }
  }

  const analyticDisplayName = (analytic) => {
    return analytic.name.length > 50 
      ? analytic.name.substring(0, 47) + '...' 
      : analytic.name
  }

  return (
    <div key={`analytics-check-${analytic.id}`} className="mt-2 d-flex align-items-start">
      <Form.Check
        disabled={disabled || (isChecked && isFiltered)}
        type="checkbox"
        id={analytic.id}
        onChange={handleToggle}
        checked={isChecked}
        label={
          <div>
            <div>
              {analyticDisplayName(analytic)}
              {/* analytics_columns serializes full attributes, so a present
                  municipality_id marks a municipality-owned custom analytic */}
              {analytic.municipality_id && (
                <span className="badge badge-primary ms-2">Custom</span>
              )}
            </div>
            {analytic.description && (
              <div className="text-muted small">{analytic.description}</div>
            )}
          </div>
        }
      />
      {isFiltered && isChecked && (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip>
              This analytics column cannot be removed because it has active filters applied
            </Tooltip>
          }
        >
          <span className="ms-2 text-primary" style={{ cursor: 'help' }}>
            <FontAwesomeIcon icon={faFilter} />
          </span>
        </OverlayTrigger>
      )}
    </div>
  )
}

export default UpdateAnalyticsColumn